






















































import { Component, Vue } from "vue-property-decorator";
import { createUserGroupFromUserACL } from "@/services/users/usersService";
import { GenerateUserGroup } from "@/services/users/types";
import { detailsValidators } from "@/components/users/validators";
import validate from "@/directives/validate";
import { validateForm } from "@/services/validation/validationService";

@Component({
    directives: {
        validate
    }
})
export default class CreateUserGroupFromUserACLModal extends Vue {
    model = {} as GenerateUserGroup;
    validators = detailsValidators;
    name = ""

    open(id: string, name: string) {
        this.model.userToCopyId = id;
        this.name = name;
        this.$bvModal.show("modal-generateUserGroup");
    }

    async confirm() {
        if (!await validateForm([this.validators])) return;
        this.$bvModal.hide("modal-generateUserGroup");
        createUserGroupFromUserACL(this.model).then(() => {
            this.$emit("goToUserGroups");
        });
        this.model = {} as GenerateUserGroup;
    }

    decline() {
        this.$bvModal.hide("modal-generateUserGroup");
    }
}
